import React, { useContext, memo } from 'react';
import Slider from 'react-slick';

import { PartnerLogosSliderContainer, PartneredCompaniesWrap, GradientLeft, PartnerLogoWrap, GradientRight } from './OurClientStyles';
import { Container, Heading, GenericDiv } from 'commonStyles';
import { partnerLogosData1, partnerLogosData2, partnerLogosData3 } from '../../config';
import { isMobileContext } from 'UtilityComponents/Util';
import DisplayContext from 'UtilityComponents/displayContext';
import { PartnerIcons } from '../../Styles';

const OurClient = () => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);

	const settings = {
		dots: false,
		infinite: true,
		slidesToShow: 7,
		slidesToScroll: 1,
		autoplay: true,
		speed: 2000,
		autoplaySpeed: 2000,
		cssEase: 'linear',
		arrows: false,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	return (
		<PartnerLogosSliderContainer>
			<Container>
				<GenericDiv
					bottom_P={isMobile ? 25 : 50}
					top_P={isMobile ? 25 : 50}
					left_P={isMobile ? 20 : 0}
					right_P={isMobile ? 20 : 0}>
					<Heading color='#fff' fontSize={`${isMobile ? '40px' : '56px'}`} marBt={`${isMobile ? '31px' : '40px'}`}>
						Our Clients
					</Heading>
					<PartneredCompaniesWrap>
						<GradientLeft />
						<>
							<Slider {...settings}>
								{partnerLogosData1.map((item) => (
									<PartnerLogoWrap key={item.logo}>
										<PartnerIcons icon={item.logo} id={item.logo} />
									</PartnerLogoWrap>
								))}
							</Slider>
							<Slider {...settings}>
								{partnerLogosData2.map((item) => (
									<PartnerLogoWrap key={item.logo}>
										<PartnerIcons icon={item.logo} id={item.logo} />
									</PartnerLogoWrap>
								))}
							</Slider>
							<Slider {...settings}>
								{partnerLogosData3.map((item) => (
									<PartnerLogoWrap key={item.logo}>
										<PartnerIcons icon={item.logo} id={item.logo} />
									</PartnerLogoWrap>
								))}
							</Slider>
						</>
						<GradientRight />
					</PartneredCompaniesWrap>
				</GenericDiv>
			</Container>
		</PartnerLogosSliderContainer>
	);
};

export default memo(OurClient);
